module.exports = __webpack_public_path__ + "img/bonus12.567656ab.png";